import React, { useState } from 'react'
import MainBox from '../MainBox/index'
import PassResetEmail from '../passReset/index'
import CodeInput from '../CodeInput/index'
import ResetPassword from '../CodeInput/indexresset'
import RegisterScreen from '../Register/index'
import ResetSuccess from '../SuccessMsg/indexsucess'
import {
  Container,
  LeftSide,
  RightSide,
  LeftOverlay,
  LeftTexts,
  LeftLogoImg,
} from './style'
import FactoryImage from './img-login/imagemordeno.png'
import FMark from './img-login/itens img.png'
interface LoginInfo {
  email: string
  password: string
}

const LoginScreen = () => {
  const [page, setPage] = useState<string>('Main')

  const [userlogin, setUserlogin] = useState<LoginInfo>({
    email: '',
    password: '',
  })

  if (page === 'PassReset') {
    return <PassResetEmail setPage={setPage} />
  }

  if (page === 'Register') {
    return <RegisterScreen setPage={setPage} />
  }

  if (page === 'CodeInput') {
    return <CodeInput setPage={setPage} />
  }

  if (page === 'ResetPassword') {
    return <ResetPassword setPage={setPage} />
  }

  if (page === 'ResetSuccess') {
    return <ResetSuccess setPage={setPage} />
  }

  return (
    <Container>
      <LeftSide style={{ backgroundImage: `url(${FactoryImage})` }}>
        <LeftOverlay />
        <LeftTexts>
          <LeftLogoImg src={FMark} alt='Logo Ordeno' />

          <h1>
            Gestão fácil,
            <br />
            resultados reais.
          </h1>
          <p>Tudo que sua fábrica precisa, em um só lugar.</p>
        </LeftTexts>
      </LeftSide>

      <RightSide>
        {page === 'Main' && (
          <MainBox setUserlogin={setUserlogin} setPage={setPage} />
        )}
      </RightSide>
    </Container>
  )
}

export default LoginScreen
